import { useEffect } from 'react';
import jsCookie from 'js-cookie';
import { apiGeneral } from 'services';
import { useDispatch } from 'react-redux';
import { AuthActions } from 'store/ducks/auth';
import Logo from 'assets/images/logo.svg';

const LoginRedirectCheck = () => {
  const dispatch = useDispatch();

  async function getData(accessToken: string) {
    apiGeneral.defaults.headers.Authorization = `Bearer ${accessToken}`;

    const { data } = await apiGeneral.get('/get-user-data');
    dispatch(AuthActions.loginSuccess({ ...data, accessToken }));
  }

  useEffect(() => {
    const accessToken = jsCookie.get('_brenntag');
    (() => {
      if (accessToken) {
        getData(accessToken);
      }
    })();
  }, []);

  return (
    <div
      style={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgb(16, 56, 79)',
        gap: '10px',
      }}
    >
      <img src={Logo} alt="brenntag logo" width={100} />
      <h2 style={{ color: '#f2f2f2' }}>Loading...</h2>
    </div>
  );
};

export default LoginRedirectCheck;
